import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, Navigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
import Toast from './Toast';

const RestrictedRoute = ({ isAdmin }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [toastMessage, setToastMessage] = useState(null);
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const isAuthenticated = !!localStorage.getItem('SecurityToken');
    let isRolesHasAdminRights = true;
    if (isAdmin && isAuthenticated) {
        let rightID = rolesAndRights.AllRights.find(el => el.DisplayName.trim().toLowerCase() === "admin").RightId;
        if (userRights.some(el => el.RightId === rightID)) {
            isRolesHasAdminRights = Number(userRights.find(el => el.RightId === rightID).RightValue) === 1 ? true : false;
        }
    }
    const isBlocked = isAuthenticated && !isRolesHasAdminRights;
    // Track last allowed route
    useEffect(() => {
        if (isAuthenticated && !isBlocked) {
            localStorage.setItem('lastAllowedRoute', location.pathname);
            console.log()
        }
    }, [isAuthenticated, isBlocked, location.pathname]);

    // Show toast and schedule redirect
    useEffect(() => {
        if (isBlocked && isAdmin) {
            setToastMessage("Access denied: Please get access and try again.");
            const lastAllowed = localStorage.getItem('lastAllowedRoute') || "/dashboard";
            const timer = setTimeout(() => {
                navigate(lastAllowed, { replace: true });
            }, 1000); // match toast duration
            return () => clearTimeout(timer);
        }
    }, [isBlocked, isAdmin, navigate]);

    if (!isAuthenticated) {
        console.log("Inside IsAuthenticated block")
        localStorage.clear();
        return <Navigate to="/" state={{ from: location }} replace />;
        // return null;
    }

    return (
        <>
            {toastMessage && (
                <Toast
                    message={toastMessage}
                    onClose={() => setToastMessage(null)}
                />
            )}
            {!isBlocked && <Outlet />}
        </>
    );
};

export default RestrictedRoute;
